module.exports = __webpack_public_path__ + "img/1572202614.c5be3efd.jpg";